import GenericNewCategoryPage from './GenericNewCategoryPage';

function ImpactfulLegacies() {
  return <GenericNewCategoryPage categoryId={16} categoryKey="impactfulLegacies" />;
}

export default ImpactfulLegacies;
